/**
 * API Configuration
 * Centralizes all API endpoint URLs for the application
 */

// Base URL for the API
// Falls back to production URL if environment variable is not set
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://gastos.neomeisters.com/api';

// API Endpoints
export const API_ENDPOINTS = {
    base: API_BASE_URL,
    transactions: `${API_BASE_URL}/transaction.php`,
    procedures: `${API_BASE_URL}/procedures.php`,
};

export default API_ENDPOINTS;
